import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService, HttpResponse } from "../http-util.service";
import { model } from "src/app/models/autopac/coe-bidding-results";

@Injectable({
  providedIn: "root",
})
export class CoeBiddingResultsService {
  constructor(private http: HttpUtilService) {}

  UploadFiles(file: ArrayBuffer, fileName: string): Observable<any> {
    const formData = new FormData();

    const blob = new Blob([file], {
      type: "application/octet-stream",
    });
    formData.append("file", blob, fileName);
    formData.append("docType", "CoeBiddingResults");

    return this.http.post("UploadFiles.ashx", formData);
  }

  UpdateCOE(model: model[], type: string): Observable<any> {
    return this.http.post("CoeBiddingResultsService.asmx/UpdateCOE", {
      model,
      type,
    });
  }
}
